import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from  "@angular/common/http";
import { constVariables } from "../../constants/ConstantPath"; 
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { PopupComponent } from '../../dialogs/popup/popup.component';
import { MatDialog } from '@angular/material';
import { CommonService } from "../../services/common.service";
@Injectable({
  providedIn: 'root'
})
export class AuthService {
	currentUrl: string;
	private loggedIn = new BehaviorSubject({});
	checkLoginStatus = this.loggedIn.asObservable();

	constructor(
		private _http: HttpClient, 
		private router: Router,
		public dialog: MatDialog,
		private commonService:CommonService
	) { 

	}

	/****************/
	/***** LOGIN ****/ 
	/****************/
	isUserLoggedin() {
		let tokenData = localStorage.getItem('AuthToken')!== null && localStorage.getItem('AuthToken')!== '' && localStorage.getItem('AuthToken')!== undefined ? JSON.parse(localStorage.getItem('AuthToken')) : '';
		let token;
		if(tokenData){
			token = tokenData.authToken;
		}else {
			token = '';
		}
	}

	/*****************/
	/* LOGIN PROCESS */ 
	/*****************/
	login(data) {
		let promise = new Promise((resolve, reject) => {
			const url = constVariables.apiUrl + "frontend/authorization/login";
			this._http.post<any[]>(url, data).subscribe((res: any) => {
				resolve(res);
			});
		});
		return promise;
	}

	/**********************/
	/** REGISTER PROCESS **/ 
	/**********************/
	register(data) {
		let promise = new Promise((resolve, reject) => {
			const url = constVariables.apiUrl + "frontend/authorization/register";
			this._http.post<any[]>(url, {'data': data}).subscribe((res: any) => {
				resolve(res);
			});
		});
		return promise;
	}

	/**********************/
	/***** USER DATA ******/ 
	/**********************/
	public getUserData(Token) {
		const url = constVariables.apiUrl +'login/isloggedIn';
		return this._http.post(url, Token);
	}

	/********************************/
	/***** USER AUTHENTICATION ******/ 
	/********************************/
	isUserAuthenticated(routeName) {
		let promise = new Promise((resolve, reject) => {
			setTimeout(() => {
			    this.currentUrl = routeName;
				let returnData: any = {};
				let tokenData = localStorage.getItem('AuthToken')!== null && localStorage.getItem('AuthToken')!== '' && localStorage.getItem('AuthToken')!== undefined ? localStorage.getItem('AuthToken') : '';
				let token = tokenData;
				if( token !== '' &&  token !== undefined &&  token !== null) {
					let tempData = {
						login_token : token
					};
					this.getUserData(tempData).subscribe((res:any) => {
						if(res['loginstatus']) {                    	
							returnData.isLoggedIn = true;
							this.updateLoggedInStatus(true);               
							resolve(res['loginstatus']);             
						} else {
							this.updateLoggedInStatus(false);
							this.openDialog({
								'message':res.Exception,
								'title':'ERROR',
								'confirm': false
							});
							this.logout();
							resolve(false);
						}
					});
				} else {
					this.logout();
					return false;
				}
			},100);
		});
		return promise;
	}

	/********************************/
	/********** USER LOGOUT *********/ 
	/********************************/
	logout() {
		this.updateLoggedInStatus(false);
		localStorage.removeItem('isLoggedIn');
		localStorage.removeItem('billingData');
		localStorage.removeItem('AuthToken');
		localStorage.removeItem('loggedInCustomerData');
		localStorage.removeItem('continueAsGuest');
		localStorage.removeItem('cartData');
		localStorage.removeItem('cartTotal');
		localStorage.removeItem('mupog');
		localStorage.removeItem('cartHotelData');
		localStorage.removeItem('travellers');
		this.commonService.isLoggedIn.next(false);
		setTimeout(()=>{
			this.router.navigate(['/manage-bookings']);
		},1000);
	}


	public checkValidConfEmail(data) {
		let promise = new Promise((resolve, reject) => {
			const url = constVariables.apiUrl + "frontend/reservations/checkValidConfEmail";
			this._http.post<any[]>(url, {'data': data}).subscribe((res: any) => {
				resolve(res);
			});
		});
		return promise;
	}

	/*
	*	Update LoggedIn status Observable
	*/ 
	updateLoggedInStatus(val) {
		this.loggedIn.next(val);
	}
	// Check email already exist
	checkEmailNotTaken(email,hotelId) {
		let promise = new Promise((resolve, reject) => {
			const url = constVariables.apiUrl + "frontend/Authorization/check_unique_customer_email";
			this._http.post<any[]>(url, {'customer_email': email,'hotel_id':hotelId}).subscribe((res: any) => {
				resolve(res);
			});
		});
		return promise;
	}

	// Check valid token 
	checkTokenWithId(token) {
		let promise = new Promise((resolve, reject) => {
			const url = constVariables.apiUrl + "frontend/Authorization/check_token_with_id";
			this._http.post<any[]>(url, {'token': token}).subscribe((res: any) => {
				resolve(res);
			},error => {
				reject(error)
			});
		});
		return promise;
	}

	// Change password
	changePassword(value) {
		let promise = new Promise((resolve, reject) => {
			const url = constVariables.apiUrl + "frontend/Authorization/reset_password";
			this._http.post<any[]>(url, value).subscribe((res: any) => {
				resolve(res);
			},error => {
				reject(error)
			});
		});
		return promise;
	}

	/**************************
	 *To Show Error  dialog box*
	**************************/
	openDialog(data): void {
		const dialogRef = this.dialog.open(PopupComponent, {
		width: '600px',
		data: data,
		panelClass: 'mlspopblock'
		});

		dialogRef.afterClosed().subscribe(res => {
		
		});
	}
}
